// generated by genversion
export var version = '3.8.2';
//# sourceMappingURL=version.js.map